import React from "react";
import styled from "styled-components";
import { device } from "theme/Breakpoints";
import { colors } from "theme/Theme";

const BestPrice: React.FC = () => {
  return (
    <BestPriceContainer>
      <h3>Гаранция за ниска цена</h3>
      <Paragraph className="text-sm">
        * Ако срещнете даден продукт от нашия онлайн магазин в друг български
        онлайн магазин на по-ниска цена, с включена доставка и монтаж, моля да
        ни посочите линк към продукта и ние ще се постараем да Ви дадем по-добра
        оферта. Може да го направите като забележка при поръчката или да ни
        пишете на имейл{" "}
        <EmailLink href="mailto:office@i-clima.com">
          office@i-clima.com
        </EmailLink>
      </Paragraph>
      <Paragraph className="text-sm">
        * Ако някои стоки в сайта Ви се струват с високи цени, моля да ни
        попитате за отстъпка на телефон{" "}
        <a href="tel:+359 894 468 805">+359 894 468 805</a> или
        <a href="tel:+359 889 269946">+359 889 269946</a>
      </Paragraph>
    </BestPriceContainer>
  );
};

//<a href="mailto:insertemailhere@xyz.com">Email</a>

const BestPriceContainer = styled.div`
  padding: 20px;
  margin: 20px 0;

  @media only screen and (${device.laptop}) {
    margin: 20px 20px;
  }
`;
const Paragraph = styled.p`
  margin: 10px 0;
`;
const EmailLink = styled.a``;

export default BestPrice;
